// Auto-generated skeleton for Tos

export const Tos: Api.Tos = {
  id: 0,
  client_tos: 0,
  content: '',
  created: null,
  updated: null,
};

